import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { track } from '@eventbrite/datalayer-library';
import { FormattedEvent, ShareUTMOptions } from '@eventbrite/event-renderer';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import React from 'react';
import DiscoverVerticalEventCard from '../../../../components/DiscoverEventCard/DiscoverVerticalEventCard';
import {
    COLLECTION_SURFACE_MAPPING,
    SEASONAL_HOLIDAY_FEATURED,
} from '../../../../constants/seasonalFeatured';
import { SEASONAL_FEATURED } from '../../constants/analytics';
import { SEASON_TO_AFFCODE_MAPPING_CURATED_MODULE } from '../../constants/seasonal';
import { useEnvContext } from '../../context';
import { useBaseEventsQueryEvents } from '../../hooks/queries/events';
import { useLocation } from '../../hooks/queries/location';
import './SeasonalCuratedContainer.scss';

interface SeasonalCuratedProps {
    seasonal: string;
}
interface TitleSection {
    seasonal: string;
}

const utmOptions: ShareUTMOptions = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': '',
    'utm-share-source': 'category-browse',
};

const TitleDescription = React.memo(({ seasonal }: TitleSection) => (
    <div className="title-subtitle-container">
        <h2 className="eds-text-hs">
            {SEASONAL_HOLIDAY_FEATURED[seasonal].title}
        </h2>
    </div>
));

export const SeasonalCurated = ({ seasonal }: SeasonalCuratedProps) => {
    const location_data = useLocation();
    const envContext = useEnvContext();
    const locale = envContext?.env?.localeInfo?.locale || 'en_US';
    const isMobile =
        typeof window !== 'undefined' && window?.innerWidth <= 768
            ? true
            : false;

    const placeId =
        location_data.data && location_data.data.placeId
            ? [location_data.data.placeId]
            : undefined;

    React.useEffect(() => {
        if (
            location_data &&
            location_data.data &&
            location_data.data.currentPlace
        ) {
            track({
                eventName: 'SeasonalCuratedContainerView',
                eventData: {
                    seasonalEvent: 'Valentine',
                    searchLocation: location_data.data.currentPlace,
                },
            });
        }
    }, [location_data]);

    const collection = useBaseEventsQueryEvents({
        queryOverload: {
            page_size: 10,
            aggs: {},
            q: undefined,
            tags: undefined,
            collections_or: COLLECTION_SURFACE_MAPPING['Seasonal'],
            include_mature_events: true,
            include_manual_events: true,
            places: placeId,
            dates: ['current_future'],
            price: 'paid',
        },
        refetchOnMount: false,
        enabled: true,
    });

    if (collection.isLoading) {
        return (
            <div>
                <LoadingSkeleton height={isMobile ? '434px' : '407px'} />
            </div>
        );
    }

    if (!collection.data || collection.data?.events.length == 0) return null;

    const events: FormattedEvent[] =
        collection.data?.events.length != 0
            ? collection.data?.events || []
            : [];
    const showNavigation = events.length > 5;

    return (
        <div className="seasonal-module">
            <div className="seasonal-featured-events">
                <div className="seasonal-featured-events-container">
                    <TitleDescription seasonal={seasonal} />
                    <div className="simple-carousel-parent">
                        <SimpleCarousel
                            useSideNavigation={showNavigation}
                            slidesVisible={{ desktop: 5, tablet: 3 }}
                        >
                            {events.map(({ urgencySignals: _, ...event }) => (
                                <div
                                    className="seasonal-featured-events-event-card"
                                    key={event.id}
                                >
                                    <DiscoverVerticalEventCard
                                        event={event}
                                        showOrganizer={false}
                                        shareOptions={{
                                            utmOptions,
                                            trackingCategory: 'eventcard',
                                        }}
                                        isAuthenticated={
                                            envContext?.user?.isAuthenticated ||
                                            false
                                        }
                                        affCode={
                                            SEASON_TO_AFFCODE_MAPPING_CURATED_MODULE[
                                                seasonal
                                            ]
                                        }
                                        statsigLocationString={
                                            SEASONAL_FEATURED
                                        }
                                        bucketLabel="Seasonal"
                                        locale={locale}
                                        isLazyImage
                                    />
                                </div>
                            ))}
                        </SimpleCarousel>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeasonalCurated;
